import { Navigate, useSearchParams } from 'react-router';

/**
 * `/personnel/acces` is retired as a standalone screen — access management now
 * lives on the employee record (`?tab=acces`). This component exists only to
 * honour the old A23 deep link (`?userId=`): it reads no data and needs no
 * permission gate, it just forwards to the employee it was linking to, or to
 * the register when it named nobody.
 *
 * It lives here rather than in `routes.tsx` because that file exports the route
 * table, and a module mixing a component with a non-component export breaks
 * fast refresh (`react-refresh/only-export-components`).
 */
export function AccesRedirect() {
  const [params] = useSearchParams();
  const userId = params.get('userId');
  return (
    <Navigate
      to={
        userId === null || userId === ''
          ? '/personnel/employes'
          : `/personnel/employes/${encodeURIComponent(userId)}?tab=acces`
      }
      replace
    />
  );
}
